import { render } from "./YoutubeInAppBrowser.vue?vue&type=template&id=6edce6ca"
import script from "./YoutubeInAppBrowser.vue?vue&type=script&lang=js"
export * from "./YoutubeInAppBrowser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__